import Vue from "vue";
import VueRouter, { RouteConfig } from "vue-router";
import { getAppToken } from "@/utils/hybirdMethods";
import store from "@/store";
import JsBridge from "@/utils/jsBridge";
import * as Sentry from "@sentry/vue";
import { getBrowser } from "@/utils/browser";
import apis from "@/apis/index";
import MyWebSocket from "@/utils/ws.new.2.0";
import { getWsUrl, getWsUrlList } from "@/utils/apiHost";

Vue.use(VueRouter);
let routerList: any = [];
function importAll(router) {
  router.keys().forEach(key => {
    routerList = routerList.concat(router(key).default);
  });
}
const modulesFiles = require.context("./modules", false, /\.ts$/);

importAll(modulesFiles);
const routes: Array<RouteConfig> = [...routerList];
// const routes: Array<RouteConfig> = [];

const router = new VueRouter({
  mode: "history",
  routes,
  scrollBehavior() {
    return { x: 0, y: 0 };
  }
});

// 将navigator.userAgent中的值转换成json对象
const userAgent = (): any => {
  const data = navigator.userAgent.substr(1).split("&"); // 第一步先转换为数组
  const _object = {}; // 创建一个空对象
  data.forEach(item => {
    const dataName = item.split("=");
    _object[dataName[0]] = dataName[1];
  });
  return _object;
};

// 创建 ws
const createSocket = async (to) => {
  const socketRouter = [
    "/h5-page-account",
    "/h5-page-transaction-home",
    "/h5-page-transaction",
    "/h5-page-futures-setup",
    "/h5-page-order",
    "/h5-page-accountDetails",
    "/h5-strategy-home",
    "/h5-strategy-execution",
    "/h5-create-strategy",
    "/ws-test"
  ];
  if(socketRouter.includes(to.path)){
    const ip = localStorage.getItem('ip');
    if(!ip){
      const ips = await apis.getIpApi();
      localStorage.setItem('ip', ips.ip);
    }
    if(!Vue.prototype.$socket){
      Vue.prototype.$socket = new MyWebSocket({
        url: getWsUrl("/tick"),
        bkUrl: getWsUrlList("/tick").join(","),
        onMsgName: "onmessage"
      });
    }
    if(!Vue.prototype.$transSocket){
      Vue.prototype.$transSocket = new MyWebSocket({
        url: getWsUrl("/ordertick"),
        bkUrl: getWsUrlList("/ordertick").join(","),
        onMsgName: "transactionOnMsg",
        closeHeart: true
      });
    }
  }
};


const showProxySettingRouter = ['/login/login-password', '/login/login-message', '/register', "/login-new"];
let pageStartTime = 0;
const loginConfigRouter = ["/login/login-password", "/login/login-message"]; //需要处理配置的登录页面
router.beforeEach(async (to: any, from: any, next: any) => {
  // 部分页面需要显示代理按钮
  if(from.path){
    localStorage.setItem('fromPath', from.path);
  }
  createSocket(to);
  if(getBrowser().isApp){
    const showProxySettingStatus = showProxySettingRouter.includes(to.path) ? 1 : 0;
    JsBridge.callHandler("showProxySetting", { status: showProxySettingStatus });
  }
  if(to.query && to.query.theme){
    const themeObj = {
      "dark": "black-theme",
      "light": "white-theme"
    }
    if(themeObj[to.query.theme] && !getBrowser().isApp){
      store.commit("common/SAVE_BGCOLOR", themeObj[to.query.theme]);
    }
  }
  // 登录配置：login_mode=1 或接口超时/失败时，统一走新登录页
  if (loginConfigRouter.includes(to.path)) {
    const redirectToLoginNew = () => {
      next({
        path: "/login-new",
        replace: true,
        query: {
          ...to.query
        }
      });
    };
    try {
      const getSystemParamData = await apis.getToolsSystemParams({
        code: "login_mode"
      });
      if (getSystemParamData.key && getSystemParamData.key === "1") {
        redirectToLoginNew();
        return;
      }
    } catch (e) {
      redirectToLoginNew();
      return;
    }
  }

  if (from.name !== null) {
    // 计算页面停留时长
    const timeSpent = new Date().getTime() - pageStartTime;
    if(timeSpent >= (window as any).$config.PAGE_STAY_TIME){
      const times = String(new Date());
      Sentry.captureMessage("PAGE_STAY_TIME", {
        level: "info",
        extra: {
          from,
          timeSpent,
          times,
          PAGE_STAY_TIME: (window as any).$config.PAGE_STAY_TIME
        }
      });
    }
  }
  // 设置新的开始时间
  pageStartTime = new Date().getTime();
  // 根据路由信息动态设置页面标题。
  if (to.path == '/h5-strategy-execution') {
    const keyValue = {
      1: '网格策略', 2: '开盘动量', 3: '日内短线'
    }
    to.meta.title = keyValue[to.query.strategyId]
  } else if (to.path == '/h5-page-account') {
    // 如果带了参数则说明是从添加计划那边过来的，额外处理导航头
    if (['0','1'].includes(to.query.activeIndex)) {
      to.meta.headerHasBack = true;
    }
    // 默认值
    else {
      to.meta.headerHasBack = false;
    }
  }
  const title = to.meta.title;
  const isKeepAlive = to.meta.keepAlive
  title && (document.title = title);
  store.commit("common/SAVE_NAV_TITLE", title);
  const userAgentValue = userAgent();
  const bgColor = localStorage.getItem('BGColor')
  const theme = userAgentValue.skinStatus
    ? +userAgentValue.skinStatus == 1 ? 'black-theme' : +userAgentValue.skinStatus == 0 ? 'white-theme' : ''
    : store.getters["common/bgColor"]
  // if(bgColor){
  //   theme = +bgColor == 1 ? 'black-theme' : +bgColor == 2 ? 'white-theme' : ''
  // }
  store.commit("common/SAVE_BGCOLOR", theme);

  // PC 访问私募基金：对齐 open-account 布局与 sessionStorage 鉴权，App 流程不变
  if (to.path.startsWith("/private-fund") && !getBrowser().isApp) {
    to.meta.isH5Page = false;
    to.meta.showHeader = false;
    to.meta.authFailToastOnly = false;
    to.meta.isH5Login = false;

    if (!sessionStorage.getItem("token")) {
      next({
        path: "/open-account/login",
        query: { redirect: to.fullPath },
        replace: true
      });
      return;
    }
  }

  getAppToken()
    .then(res => {
      // get Pro下开户前，先登录
      if (res === "isGetPro" && to.path === "/mode-select") {
        next({
          path: "/login/login-password?phone=" + localStorage.getItem("phone"),
          replace: true
        });
      } else {
        if(isKeepAlive){
          const box: any = document.getElementById("app");
          if(box.scrollTo){
            box.scrollTo(0,0)
          }else{
            box.scrollTop = 0
          }
        }
        next();
      }
    })
    .catch(() => {
      next();
    });
});
router.afterEach((to, from) =>{
  setTimeout(()=>{
    const app = document.getElementById('app');
    if(app){
      app.scrollTo(0, 0);
    }
  },60)
})

export default router;
